import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StartOverFlow, StartOverStateCleared } from '@store/actions/start-over/start-over.actions';
import { map } from 'rxjs';

@Injectable()
export class StartOverEffects {
  constructor(private actions$: Actions) {}

  StartOverFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StartOverFlow),
      map(() => StartOverStateCleared()),
    ),
  );
}
